import { Base64 } from 'js-base64';
import Quill from 'quill';

import { Component, Input, OnInit } from '@angular/core';
import { getQuill } from 'src/app/core/helpers/quill-plugin-wrapper';
import { TRichText } from 'src/app/project/components/input/rich-text/rich-text-ops.model';

@Component({
    selector: 'pp-description-dashlet-activity',
    templateUrl: './description-dashlet-activity.component.html',
    styleUrls: ['./description-dashlet-activity.component.scss'],
    standalone: false
})
export class DescriptionDashletActivityComponent implements OnInit {
  @Input() ppDescription: string;
  @Input() ppPlainText = '';
  @Input() ppComment = false;

  expanded = false;
  long = false;

  private quillEditor: Quill = null;
  private richText: TRichText;
  private length: number = null;
  private splitText: string[] = [];
  private readonly Quill = getQuill();

  ngOnInit() {
    if (this.ppDescription) {
      try {
        this.richText = JSON.parse(Base64.decode(this.ppDescription));
      } catch {}
    }
  }

  initEditor(descriptionElement: HTMLElement): void {
    this.quillEditor = new this.Quill(descriptionElement, {
      readOnly: true,
      modules: {
        toolbar: false,
      },
    });

    this.initContent();
  }

  expandDescription(): void {
    this.expanded = true;

    if (this.richText) {
      this.quillEditor.setContents(this.richText.ops);
    }
  }

  collapseDescription(): void {
    this.expanded = false;

    if (this.richText) {
      this.quillEditor.setContents(this.richText.ops);

      this.trimTextLines();
    }
  }

  private initContent(): void {
    if (this.richText) {
      this.quillEditor.setContents(this.richText.ops);
    } else {
      this.quillEditor.setText(this.ppPlainText);
    }

    this.length = this.quillEditor.getText().trim().length;
    this.splitText = this.quillEditor.getText().split(/\r\n|\r|\n/);

    this.trimTextLines();
  }

  private trimTextLines(): void {
    if (this.splitText.length > 3) {
      let lengthToTrim =
        this.splitText[0].length + this.splitText[1].length + this.splitText[2].length;

      if (lengthToTrim > 200) {
        lengthToTrim = 200;
      }

      this.long = true;
      this.quillEditor.editor.deleteText(lengthToTrim, this.length);
      this.quillEditor.editor.insertText(lengthToTrim, '...', 'bold', true);
    } else if (this.length > 200) {
      this.long = true;
      this.quillEditor.editor.deleteText(200, this.length);
      this.quillEditor.editor.insertText(200, '...', 'bold', true);
    }
  }
}
